import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { formatNull, formatDate } from '../Utils/GlobalUtils';

import DebtorCases from '../Components/DebtorComponents/DebtorCases';
import CommentsDebtor from '../Components/DebtorComponents/CommentsDebtor';

import Loading from '../Components/Loading';
import WarningPanel from '../Components/WarningPanel';
import HeadlinePanel from '../Components/HeadlinePanel';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as PenIcon } from '../icons/pen.svg';

export default function PageOfDebtor() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [debtorInfo, setDebtorInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        
        axios.get(`/api/get-full-info-debtor?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setWarning('');
            setDebtorInfo(response.data);
            document.title = `${response.data.name} — Личный кабинет Альянс`;
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, id]);

    const [access, setAccess] = React.useState(false);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get('/api/get-my-user-role', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            const hasAccess = response.data.role == 'АппаратСРО';
            setAccess(hasAccess);
        }).catch(err => {
            console.error(`Ошибка получения данных: ${err}`);
        })
    }, []);
   
    return (
        <div className='mainContainer'>
            <HeadlinePanel label='Карточка должника' type='Назад' />
            <div className='containerInner'>
                <div className='pageWrapper'>
                    <div className='pageLimiter'>
                        {loading ? <Loading />
                        : warning ? <WarningPanel text={warning} buttonText='Повторить попытку' buttonAction={() => {setLoading(true)}} />
                        : 
                        <>
                            <div className='iconTopRight'>
                                <button
                                    type='button'
                                    className='miniButton'
                                    onClick={() => navigate(`/change-debtor/${debtorInfo.id}`)}
                                >
                                    <IconContainer
                                        Icon={PenIcon}
                                        isClickable={false}
                                        size='16'
                                        color='blue'
                                    />
                                    Изменить данные
                                </button>
                            </div>
                            <h3 className='formHeadline'>Основная информация</h3>
                            <div className='labelInputWrapper'>
                                <a className='label'>
                                    {debtorInfo.entity_type==='Физическое лицо' && 'ФИО'}
                                    {debtorInfo.entity_type==='Юридическое лицо' && 'Наименование'}
                                </a>
                                <div className='labelInputRight paddingRight'>
                                    <a>{formatNull(debtorInfo.name)}</a>
                                </div>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Категория должника</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.entity_type)}</a>
                                </div>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Регион банкротства</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.region_name)}</a>
                                </div>
                            </div>
                            {debtorInfo.entity_type==='Физическое лицо' &&
                            <>
                                <div className='labelInputWrapper'>
                                    <a className='label'>Дата рождения</a>
                                    <div className='labelInputRight'>
                                        <a>{formatDate(debtorInfo.date_of_birth)}</a>
                                    </div>
                                </div>
                                <div className='labelInputWrapper'>
                                    <a className='label'>Место рождения</a>
                                    <div className='labelInputRight'>
                                        <a>{formatNull(debtorInfo.place_of_birth)}</a>
                                    </div>
                                </div>
                            </>}
                            <div className='labelInputWrapper'>
                                <a className='label'>Адрес</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.postal_address)}</a>
                                </div>
                            </div>

                            <div style={{height: '20px'}}></div>

                            <h3 className='formHeadline'>Документы</h3>
                            <div className='labelInputWrapper'>
                                <a className='label'>ИНН</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.TIN)}</a>
                                </div>
                            </div>
                            {debtorInfo.entity_type==='Физическое лицо' &&
                            <div className='labelInputWrapper'>
                                <a className='label'>СНИЛС</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.SNILS)}</a>
                                </div>
                            </div>}
                            <div className='labelInputWrapper'>
                                <a className='label'>
                                    {debtorInfo.entity_type==='Физическое лицо' && 'ОГРНИП'}
                                    {debtorInfo.entity_type==='Юридическое лицо' && 'ОГРН'}
                                </a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.OGRN)}</a>
                                </div>
                            </div>

                            <div style={{height: '20px'}}></div>

                            <h3 className='formHeadline'>Дополнительное</h3>
                            <div className='labelInputWrapper'>
                                <a className='label'>Примечание</a>
                                <div className='labelInputRight'>
                                    <a>{formatNull(debtorInfo.description)}</a>
                                </div>
                            </div>
                            <div className='labelInputWrapper'>
                                <a className='label'>Карточки, к которым прикреплен должник</a>
                                <div className='labelInputRight'>
                                    <DebtorCases
                                        debtorId={id}
                                        case_ids={debtorInfo.case_ids || []}
                                        reload={reload}
                                        onSuccess={() => setReload(true)}
                                        access={access}
                                        isShowButtons={true}
                                        isShowEditButton={false}
                                    />
                                </div>
                            </div>
                            {/* <h3 className='formHeadline'>Связь</h3>
                            <div className='labelInputWrapper'>
                                <a className='label'>Сообщения</a>
                                <div className='labelInputRight'>
                                    <CommentsDebtor debtorId={debtorInfo.id} access={access} userId={debtorInfo.user_id} onSuccess={() => {setReload(true)}} />
                                </div>
                            </div> */}

                            <div style={{height: '50px'}}></div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}
